import { useAppSelector } from "~/store/hooks";
import { CropScope, useCustomerCropScope } from "~/utils/crops/use-crop-list";

import { getSingleImportCustomerGuid } from "./selectors";

/** Single matched customer, else Catalog. */
export const useImportCropScope = (): CropScope =>
    useCustomerCropScope(useAppSelector(getSingleImportCustomerGuid));
